"use client";
import { j as e } from "./index.es44.js";
import { useState as u, useMemo as h, useEffect as x } from "react";
import { makeUniqueId as b, composeClassNames as g } from "./index.es126.js";
import j from "./index.es129.js";
import v from "./index.es130.js";
const C = ({
  header: d,
  headingLevels: l = 2,
  children: m = null,
  isOpen: a = !1,
  onClick: o = void 0,
  isBackgroundWhite: p = !1,
  langAriaSteps: f,
  contentId: s
}) => {
  const [r, i] = u(a), n = h(() => b(), []), c = () => {
    i(!r);
  };
  return x(() => {
    i(a);
  }, [a]), /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: g(
        "bl-accordion",
        p && "bl-accordion--is-white",
        r ? "bl-accordion--is-open" : "bl-accordion--is-closed"
      ),
      children: [
        /* @__PURE__ */ e.jsx(
          j,
          {
            headingLevel: l,
            className: "bl-accordion__header",
            children: /* @__PURE__ */ e.jsx(
              v,
              {
                header: d,
                onClick: o || c,
                onKeyDown: (t) => {
                  t.key === "Enter" && (t.preventDefault(), o ? o() : c());
                },
                "aria-expanded": r ? "true" : "false",
                "aria-controls": s || n,
                langAriaSteps: f
              }
            )
          }
        ),
        /* @__PURE__ */ e.jsx("div", { id: s || n, className: "bl-accordion__content", children: m })
      ]
    }
  );
};
export {
  v as AccordionHeaderButton,
  j as AccordionHeaderTag,
  C as default
};
//# sourceMappingURL=index.es56.js.map
